import BroadcastTemplatePreview from '@components/UI/BroadcastTemplatePreview';
import { TextField } from '@material-ui/core';
import { WhatsAppTemplate } from '@src/types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import './TemplateList.css';

interface ITemplateList {
  activeTemplates: WhatsAppTemplate[];
  selectedTemplateId: number;
  handleSelectedTemplate: (id: number) => void;
}

const TemplateList = ({
  activeTemplates,
  selectedTemplateId,
  handleSelectedTemplate,
}: ITemplateList): JSX.Element => {
  const [templates, setTemplates] = useState([] as WhatsAppTemplate[]);

  const buildTemplateList = () => (
    <div id="tpt-list">
      {templates.map(template => {
        const { id } = template;
        return (
          <div
            key={id}
            id={`${id}`}
            role="none"
            onClick={() => handleSelectedTemplate(id)}
            className={`tpt ${
              `${selectedTemplateId}` === `${id}` ? 'tpt-active' : ''
            }`}
          >
            <BroadcastTemplatePreview key={id} summary template={template} />
          </div>
        );
      })}
    </div>
  );

  const buildTemplateTF = () => (
    <div id="tpt-search">
      <TextField
        id="search-template-to-contact"
        label={<FormattedMessage id="TemplatedMsg.searchTemplate" />}
        type="search"
        variant="standard"
        onChange={e => {
          const { value } = e.target;
          const filteredTemplates = activeTemplates.filter(at =>
            at.name.trim().includes(value.trim())
          );
          if (filteredTemplates) setTemplates(filteredTemplates);
        }}
        fullWidth
        margin="normal"
      />
    </div>
  );

  useEffect(() => {
    if (templates.length === 0) setTemplates(activeTemplates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {buildTemplateTF()}
      {buildTemplateList()}
    </>
  );
};

export default TemplateList;
